import styled from 'styled-components';
import { gte } from '@lendi-ui/breakpoint';
import { Button } from '@lendi-ui/button';
import { bg, color } from '@lendi-ui/color';
import { depth } from '@lendi-ui/depth';
import { mb, ml, mr, mx, my, mt, p, pb, pl, pr, pt } from '@lendi-ui/spacing';
import { body, heading, link } from '@lendi-ui/typography';
import { display } from '@lendi-ui/utils';

export const Wrapper = styled.div`
  ${my('md')}
  ${p('md')}
  ${pb('sm')}
  ${bg('secondary.25')}
  ${depth(1)}
  border-radius: 6px;
`;

export const Title = styled.h4`
  ${heading({ size: 'sm', color: 'secondary.500' })}
  ${mt('nil')}
  ${mb('sm')}
`;

export const InputGroup = styled.div`
  ${display({ mobile: 'block', tablet: 'flex' })}
  ${my('nil')}
  margin-left: calc(-0.5 * var(--lendi-ui-size));
  margin-right: calc(-0.5 * var(--lendi-ui-size));
  ${gte('tablet')`
    align-items: flex-end;
  `}
  > * {
    ${mx('xxs')}
    ${mb('sm')}
  }
`;

export const Label = styled.label`
  display: block;
  ${mx('xxs')}
  ${mb('sm')}
  > span {
    display: inline-block;
    ${mb('xxxs')}
  }
`;

export const InputExtra = styled.span<{ side: 'left' | 'right' }>`
  ${({ side }) => ml(side === 'left' ? 'xs' : 'xxxs')}
  ${({ side }) => mr(side === 'left' ? 'xxxs' : 'xs')}
`;

export const PropertyReportLink = styled.a`
  ${link()}
  text-decoration: none;
`;

export const CalculateButton = styled(Button)`
  white-space: nowrap;
`;

export const ResetButton = styled.button`
  ${link({ size: 'md', color: 'primary.500' })}
  ${mb('xxs')}
  float: right;
  border: none;
  background: none;
  text-decoration: none;
  > * {
    ${mt('xxxs')}
    vertical-align: top;
  }
`;

export const ResultsWrapper = styled.div`
  ${display({ mobile: 'block', tablet: 'flex' })}
  clear: both;
`;

export const QuoteSection = styled.div`
  ${pb({ mobile: 'md', tablet: 'nil' })}
  ${pr({ mobile: 'nil', tablet: 'sm', desktop: 'md' })}
  border-bottom: 1px solid ${color('shade.100')};
  ${gte('tablet')`
    flex: 0;
    min-width: 19rem;
    border-bottom: none;
    border-right: 1px solid ${`${color('shade.100')}`};
  `}
  ${gte('desktop')`
    min-width: 21rem;
  `}
`;

export const QuoteAmount = styled.span`
  ${heading({ size: 'xl', color: 'primary.700' })}
`;

export const QuotePeriod = styled.span`
  ${body({ size: 'lg', color: 'shade.500' })}
  ${ml('xxs')}
`;

export const CtaSection = styled.div`
  ${pt({ mobile: 'md', tablet: 'nil' })}
  ${pl({ mobile: 'nil', tablet: 'sm', desktop: 'md' })}
`;

export const MoreCtas = styled.div`
  ${mt('sm')}
  display: flex;
  justify-content: space-evenly;

  a,
  button {
    background: none;
    border: none;
    span {
      vertical-align: middle;
    }
  }
`;
